import store from './../store';
import {
  MODAL_FIX_CLOSE,
  MODAL_FIX_NEXT_STEP,
  MODAL_FIX_OPEN,
  MODAL_FIX_PREV_STEP,
  MODAL_FIX_SKIP_STEP,
  MODAL_FIX_TRIGGER_NEXT, MODAL_FIX_UPDATE_FEATURE_ID,
} from "./actionTypes";
import {
  createModalFixSnapshot,
  restoreFromSnapshot
} from "../bvcomponents/sqft/components/popup/modalFix/CompatibilityWarnings/modalFixHelper";
import {setSQFTCartItemsToAdd} from "./sqftResourceFunctions";
import {setSQFTInVisualizer} from "./sqftFunctions";
import {setWizardConflictSteps} from "./wizardFunctions";
import sqftConfig from "../bvcomponents/sqft/components/canvas/store/sqftConfig";

export const openModalFix = (id, steps, onComplete = null) => (dispatch) => {
  // Create snapshot before opening modal (fast - no images)
  const snapshot = createModalFixSnapshot();

  dispatch({
    type: MODAL_FIX_OPEN,
    payload: { id, steps, onComplete, snapshot }
  });

  // Call onStepEnter callback for first step
  const firstStepData = steps[0];
  if (firstStepData && firstStepData.onStepEnter && typeof firstStepData.onStepEnter === 'function') {
    firstStepData.onStepEnter(firstStepData, dispatch);
  }
};

export const closeModalFix = (shouldRestore = true) => async (dispatch) => {
  const state = store.getState();
  const { sqftModalFixState } = state;

  // Call onStepExit callback for current step
  if (sqftModalFixState.isModalFixOpen && sqftModalFixState.steps.length > 0) {
    const currentStepData = sqftModalFixState.steps[sqftModalFixState.currentStep - 1];
    if (currentStepData && currentStepData.onStepExit && typeof currentStepData.onStepExit === 'function') {
      currentStepData.onStepExit(currentStepData, dispatch);
    }
  }

  // Restore from snapshot only when canceling (not when finishing)
  if (shouldRestore && sqftModalFixState.snapshot) {
    await restoreFromSnapshot(sqftModalFixState.snapshot);
  }
  dispatch(setSQFTInVisualizer(false));
  dispatch(setSQFTCartItemsToAdd([]));
  dispatch(setWizardConflictSteps([]));
  sqftConfig.initializeDependentProperties();

  dispatch({ type: MODAL_FIX_CLOSE });
};

export const nextStepModalFix = () => (dispatch) => {
  const state = store.getState();
  const { sqftModalFixState } = state;

  if (sqftModalFixState.currentStep < sqftModalFixState.totalSteps) {
    // Call onStepExit callback for current step if it exists
    const currentStepData = sqftModalFixState.steps[sqftModalFixState.currentStep - 1];
    if (currentStepData && currentStepData.onStepExit && typeof currentStepData.onStepExit === 'function') {
      currentStepData.onStepExit(currentStepData, dispatch);
    }

    dispatch({ type: MODAL_FIX_NEXT_STEP });

    // Get updated state after step change
    const newState = store.getState();
    const { sqftModalFixState: updatedSqftModalFixState } = newState;
    const nextStepData = updatedSqftModalFixState.steps[updatedSqftModalFixState.currentStep - 1];

    // Call onStepEnter callback for new step if it exists
    if (nextStepData && nextStepData.onStepEnter && typeof nextStepData.onStepEnter === 'function') {
      nextStepData.onStepEnter(nextStepData, dispatch);
    }
  } else {
    // Last step completed
    const currentStepData = sqftModalFixState.steps[sqftModalFixState.currentStep - 1];
    if (currentStepData && currentStepData.onStepExit && typeof currentStepData.onStepExit === 'function') {
      currentStepData.onStepExit(currentStepData, dispatch);
    }

    dispatch({ type: MODAL_FIX_NEXT_STEP });
  }
};

export const prevStepModalFix = () => (dispatch) => {
  const state = store.getState();
  const { sqftModalFixState } = state;

  if (sqftModalFixState.currentStep > 1) {
    // Call onStepExit callback for current step if it exists
    const currentStepData = sqftModalFixState.steps[sqftModalFixState.currentStep - 1];
    if (currentStepData && currentStepData.onStepExit && typeof currentStepData.onStepExit === 'function') {
      currentStepData.onStepExit(currentStepData, dispatch);
    }

    dispatch({ type: MODAL_FIX_PREV_STEP });

    // Get updated state after step change
    const newState = store.getState();
    const { sqftModalFixState: updatedSqftModalFixState } = newState;
    const prevStepData = updatedSqftModalFixState.steps[updatedSqftModalFixState.currentStep - 1];

    // Call onStepEnter callback for previous step if it exists
    if (prevStepData && prevStepData.onStepEnter && typeof prevStepData.onStepEnter === 'function') {
      prevStepData.onStepEnter(prevStepData, dispatch);
    }
  }
};

export const skipStepModalFix = () => (dispatch) => {
  const state = store.getState();
  const { sqftModalFixState } = state;

  // Call onStepExit callback for current step if it exists
  const currentStepData = sqftModalFixState.steps[sqftModalFixState.currentStep - 1];
  if (currentStepData && currentStepData.onStepExit && typeof currentStepData.onStepExit === 'function') {
    currentStepData.onStepExit(currentStepData, dispatch);
  }

  dispatch({ type: MODAL_FIX_SKIP_STEP });
};

export const triggerNextStepModalFix = () => (dispatch) => {
  const state = store.getState();
  const { sqftModalFixState } = state;

  if (sqftModalFixState.isModalFixOpen && sqftModalFixState.showNext) {
    // Call onStepExit callback for current step if it exists
    const currentStepData = sqftModalFixState.steps[sqftModalFixState.currentStep - 1];
    if (currentStepData && currentStepData.onStepExit && typeof currentStepData.onStepExit === 'function') {
      currentStepData.onStepExit(currentStepData, dispatch);
    }

    dispatch({ type: MODAL_FIX_TRIGGER_NEXT });

    // Get updated state after step change
    const newState = store.getState();
    const { sqftModalFixState: updatedSqftModalFixState } = newState;

    if (updatedSqftModalFixState.currentStep <= updatedSqftModalFixState.totalSteps) {
      const nextStepData = updatedSqftModalFixState.steps[updatedSqftModalFixState.currentStep - 1];

      // Call onStepEnter callback for new step if it exists
      if (nextStepData && nextStepData.onStepEnter && typeof nextStepData.onStepEnter === 'function') {
        nextStepData.onStepEnter(nextStepData, dispatch);
      }
    }
  }
};
export const updateFeatureIdModalFix = (featureId, featureName = null) => (dispatch) => {
  dispatch({
    type: MODAL_FIX_UPDATE_FEATURE_ID,
    payload: { featureId, featureName }
  });
};
